// Local Storage
export const LS_LANGUAGE = 'wishmaker_language';
export const LS_CURRENCY = 'wishmaker_currency';
export const LS_ACCESS_TOKEN = 'wishmaker_access_token';
export const LS_REFRESH_TOKEN = 'wishmaker_refresh_token';
export const LS_REDIRECT_URL = 'wishmaker_redirect_url';

// UNAUTHORIZED ROUTES
export const ROUTE_FINISH_REGISTRATION = '/finish-registration/:wmNumber';
export const ROUTE_PERSONAL_INFORMATION_PROCESSING = '/personal-information-processing/:wmNumber';

// Public mobile signature route
export const ROUTE_MOBILE_SIGNATURE = '/mobile-signature';

// Phone verification required route
export const ROUTE_PHONE_VERIFICATION_REQUIRED = '/phone-verification-required';

// GLOBAL ROUTES
export const ROUTE_DASHBOARD = '/';
export const ROUTE_MAILBOX = '/mailbox';
export const ROUTE_REQUESTS = '/requests';
export const ROUTE_PROFILE = '/profile';
export const ROUTE_GUARANTEE_FUND = '/guarantee-fund';

// INVESTOR ONLY ROUTES
export const ROUTE_EARNINGS_CALCULATOR = '/earnings-calculator';
export const ROUTE_INVESTMENTS = '/investments';
export const ROUTE_INVESTMENT_DETAIL = '/investments/:id/:offerId?';
export const ROUTE_INVEST_MANAGE = '/invest-manage/:tab?';
export const ROUTE_INVEST_MANAGE_PLAIN = '/invest-manage';
export const ROUTE_SECONDARY_MARKET = '/secondary-market';

// FAQ ROUTES
export const ROUTE_FAQ = '/faq';
export const ROUTE_FAQ_RESULTS = '/faq/results/:term';
export const ROUTE_FAQ_DETAIL = '/faq/detail/:id';

